import React, { useEffect } from "react";
import "./Fooddetails.scss";
import { NavLink, useParams } from "react-router-dom";
import { FoodApi } from "../../FoodApi";
import { useFoodContext } from "../../context/ProductContext";
import { Tilt } from "react-tilt";
import { useCartContext } from "../../context/CartContext";

const Fooddetails = () => {
  const { getSingleFoods, singleFoods, isSingleLoading } = useFoodContext();
  const { id } = useParams();
  const { addToCart } = useCartContext();
  const amount = 1;
  useEffect(() => {
    getSingleFoods(FoodApi, id);
  }, []);
  const imgTilt = {
    reverse: false,
    max: 15,
    scale: 1,
  };
  return (
    <div className="foodDetails ml-auto  mt-28 pb-12 ">
      <div className="fooddetail-header flex items-center justify-around flex-wrap px-5 md:px-0">
        <div className="header-left w-full md:w-5/12 flex justify-center items-center">
          <Tilt options={imgTilt}>
            <img src={singleFoods[0]?.image} alt="" className="object-cover" />
          </Tilt>
        </div>
        <div className="header-right w-full md:w-6/12">
          <h2 className="text-3xl font-semibold mb-3">
            {singleFoods[0]?.name}
          </h2>
          <span className="text-themegray ">
            With {singleFoods[0]?.ingredients[0]}
          </span>
          <div className="rating flex items-center my-3">
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.10326 0.816986C8.47008 0.0737399 9.52992 0.07374 9.89674 0.816986L11.7063 4.48347C11.8519 4.77862 12.1335 4.98319 12.4592 5.03051L16.5054 5.61846C17.3256 5.73765 17.6531 6.74562 17.0596 7.32416L14.1318 10.1781C13.8961 10.4079 13.7885 10.7389 13.8442 11.0632L14.5353 15.0931C14.6754 15.91 13.818 16.533 13.0844 16.1473L9.46534 14.2446C9.17402 14.0915 8.82598 14.0915 8.53466 14.2446L4.91562 16.1473C4.18199 16.533 3.32456 15.91 3.46467 15.0931L4.15585 11.0632C4.21148 10.7389 4.10393 10.4079 3.86825 10.1781L0.940385 7.32416C0.346867 6.74562 0.674378 5.73765 1.4946 5.61846L5.54081 5.03051C5.86652 4.98319 6.14808 4.77862 6.29374 4.48347L8.10326 0.816986Z"
                fill="#FC8019"
              ></path>
            </svg>
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.10326 0.816986C8.47008 0.0737399 9.52992 0.07374 9.89674 0.816986L11.7063 4.48347C11.8519 4.77862 12.1335 4.98319 12.4592 5.03051L16.5054 5.61846C17.3256 5.73765 17.6531 6.74562 17.0596 7.32416L14.1318 10.1781C13.8961 10.4079 13.7885 10.7389 13.8442 11.0632L14.5353 15.0931C14.6754 15.91 13.818 16.533 13.0844 16.1473L9.46534 14.2446C9.17402 14.0915 8.82598 14.0915 8.53466 14.2446L4.91562 16.1473C4.18199 16.533 3.32456 15.91 3.46467 15.0931L4.15585 11.0632C4.21148 10.7389 4.10393 10.4079 3.86825 10.1781L0.940385 7.32416C0.346867 6.74562 0.674378 5.73765 1.4946 5.61846L5.54081 5.03051C5.86652 4.98319 6.14808 4.77862 6.29374 4.48347L8.10326 0.816986Z"
                fill="#FC8019"
              ></path>
            </svg>
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.10326 0.816986C8.47008 0.0737399 9.52992 0.07374 9.89674 0.816986L11.7063 4.48347C11.8519 4.77862 12.1335 4.98319 12.4592 5.03051L16.5054 5.61846C17.3256 5.73765 17.6531 6.74562 17.0596 7.32416L14.1318 10.1781C13.8961 10.4079 13.7885 10.7389 13.8442 11.0632L14.5353 15.0931C14.6754 15.91 13.818 16.533 13.0844 16.1473L9.46534 14.2446C9.17402 14.0915 8.82598 14.0915 8.53466 14.2446L4.91562 16.1473C4.18199 16.533 3.32456 15.91 3.46467 15.0931L4.15585 11.0632C4.21148 10.7389 4.10393 10.4079 3.86825 10.1781L0.940385 7.32416C0.346867 6.74562 0.674378 5.73765 1.4946 5.61846L5.54081 5.03051C5.86652 4.98319 6.14808 4.77862 6.29374 4.48347L8.10326 0.816986Z"
                fill="#FC8019"
              ></path>
            </svg>
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.10326 0.816986C8.47008 0.0737399 9.52992 0.07374 9.89674 0.816986L11.7063 4.48347C11.8519 4.77862 12.1335 4.98319 12.4592 5.03051L16.5054 5.61846C17.3256 5.73765 17.6531 6.74562 17.0596 7.32416L14.1318 10.1781C13.8961 10.4079 13.7885 10.7389 13.8442 11.0632L14.5353 15.0931C14.6754 15.91 13.818 16.533 13.0844 16.1473L9.46534 14.2446C9.17402 14.0915 8.82598 14.0915 8.53466 14.2446L4.91562 16.1473C4.18199 16.533 3.32456 15.91 3.46467 15.0931L4.15585 11.0632C4.21148 10.7389 4.10393 10.4079 3.86825 10.1781L0.940385 7.32416C0.346867 6.74562 0.674378 5.73765 1.4946 5.61846L5.54081 5.03051C5.86652 4.98319 6.14808 4.77862 6.29374 4.48347L8.10326 0.816986Z"
                fill="#FC8019"
              ></path>
            </svg>
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.10326 0.816986C8.47008 0.0737399 9.52992 0.07374 9.89674 0.816986L11.7063 4.48347C11.8519 4.77862 12.1335 4.98319 12.4592 5.03051L16.5054 5.61846C17.3256 5.73765 17.6531 6.74562 17.0596 7.32416L14.1318 10.1781C13.8961 10.4079 13.7885 10.7389 13.8442 11.0632L14.5353 15.0931C14.6754 15.91 13.818 16.533 13.0844 16.1473L9.46534 14.2446C9.17402 14.0915 8.82598 14.0915 8.53466 14.2446L4.91562 16.1473C4.18199 16.533 3.32456 15.91 3.46467 15.0931L4.15585 11.0632C4.21148 10.7389 4.10393 10.4079 3.86825 10.1781L0.940385 7.32416C0.346867 6.74562 0.674378 5.73765 1.4946 5.61846L5.54081 5.03051C5.86652 4.98319 6.14808 4.77862 6.29374 4.48347L8.10326 0.816986Z"
                fill="#c8c8c8"
              ></path>
            </svg>
            <span className="text-themegray italic ml-2">(21)</span>
          </div>
          <div className="intruction">{singleFoods[0]?.description}</div>
          <div className="Nutrition">
            <h3 className="italic font-semibold">Nutrition</h3>
            {singleFoods[0]?.ingredients.map((e) => {
              return <p>{e}</p>;
            })}
          </div>
          <div className="process">
            <h3 className="italic font-semibold">Details</h3>
            {singleFoods[0]?.instructions}
          </div>
          <div className="price flex items-center my-4">
            <span className="text-themegray inline-block ">Price:</span>
            <div className="rs ml-10 font-semibold">
              Rs.{singleFoods[0]?.price}{" "}
            </div>
          </div>
          <NavLink to='/'
            onClick={() =>
              addToCart(
                singleFoods[0]?.id,
                singleFoods[0]?.image,
                singleFoods[0]?.name,
                singleFoods[0]?.price,
                amount,
                singleFoods[0]
              )
            }
            className="w-full inline-block text-center py-4 bg-themeorange text-white rounded-md hover:bg-themedeeporange transition"
          >
            Add to Cart
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Fooddetails;
